import { v4 as uuidv4 } from "uuid";
import { states } from "js/placeholderData/states";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { screenScrollTo } from "js/utilities";

import FormInputError from "components/General/FormInputError";
import { useTranslation } from "react-i18next";
import RELEASING_AutoCompleteComboBox from "components/General/AutoCompleteComboBox/RELEASING_AutoCompleteComboBox";

export default function FACStepThree({
  formStep,
  setFormStep,
  setFACFormData,
}) {
  const {
    register: FACStepThreeRegister,
    handleSubmit: FACStepThreeHandleSubmit,
    formState: { errors },
    control,
    setValue,
    setError,
    clearErrors,
  } = useForm();

  const uuid = uuidv4();
  const { t } = useTranslation();
  const MAXIMUMWORDCOUNT = 150;
  const [currentWordCount, setCurrentWordCount] = useState(0);
  const [selectedState, setSelectedState] = useState({ value: "all" });
  const [selectedRelationship, setSelectedRelationship] = useState({
    value: "all",
  });

  const onSubmit = (data) => {
    // screenScrollTo();
    setFormStep(4);
    setFACFormData((currentFormData) => {
      return {
        ...currentFormData,
        ...data,
      };
    });
  };

  return (
    <>
      {formStep === 3 && (
        <div>
          <p className="text-xs">{t("FACStep-three-title")}</p>

          <form onSubmit={FACStepThreeHandleSubmit(onSubmit)}>
            <hr />
            <div className="mt-6 grid gap-4 grid-cols-1 lg:gap-6">
              <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,1fr,1fr]">
                <div>
                  <label htmlFor={`${uuid}-fn-mailing`} className="block mb-1">
                    {t("FACStep-three-fn")}
                  </label>
                  <input
                    id={`${uuid}-fn-mailing`}
                    type="text"
                    placeholder="First Name"
                    {...FACStepThreeRegister(`mailingFirstName`, {
                      required: `Please enter a first name for mailing`,
                    })}
                  />
                  <FormInputError
                    id={`${uuid}-fn-mailing-error`}
                    errorMessage={errors?.mailingFirstName?.message}
                  />
                </div>

                <div>
                  <label htmlFor={`${uuid}-ln-mailing`} className="block mb-1">
                    {t("FACStep-three-ln")}
                  </label>
                  <input
                    id={`${uuid}-ln-mailing`}
                    type="text"
                    placeholder="Last Name"
                    {...FACStepThreeRegister(`mailingLastName`, {
                      required: `Please enter a last name for mailing`,
                    })}
                  />
                  <FormInputError
                    id={`${uuid}-ln-mailing-error`}
                    errorMessage={errors?.mailingLastName?.message}
                  />
                </div>

                <div>
                  <label htmlFor={`${uuid}-cn-mailing`} className="block mb-1">
                    {t("FACStep-three-company-name")}
                  </label>
                  <input
                    id={`${uuid}-cn-mailing`}
                    type="text"
                    placeholder="Company Name"
                    {...FACStepThreeRegister(`mailingCompanyName`)}
                  />
                  <FormInputError
                    id={`${uuid}-cn-mailing-error`}
                    errorMessage={errors?.mailingCompanyName?.message}
                  />
                </div>
              </div>

              <div className="md:w-4/5">
                <label htmlFor={`${uuid}-ma-mailing`} className="block mb-1">
                  {t("FACStep-three-mailling-ads-1")}
                </label>
                <input
                  id={`${uuid}-ma-mailing`}
                  type="text"
                  placeholder="Mailing Address"
                  {...FACStepThreeRegister(`mailingAddress`, {
                    required: "Please enter mailing address",
                  })}
                />
                <FormInputError
                  id={`${uuid}-ma-mailing-error`}
                  errorMessage={errors?.mailingAddress?.message}
                />
              </div>

              <div className="md:w-4/5">
                <label htmlFor={`${uuid}-ma2-mailing`} className="block mb-1">
                  {t("FACStep-three-mailling-ads-2")}
                </label>
                <input
                  id={`${uuid}-ma2-mailing`}
                  type="text"
                  placeholder="Mailing Address Line 2"
                  {...FACStepThreeRegister(`mailingAddress2`)}
                />
                <FormInputError
                  id={`${uuid}-ma2-mailing-error`}
                  errorMessage={errors?.mailingAddress2?.message}
                />
              </div>

              <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,1fr,1fr]">
                <div>
                  <label
                    htmlFor={`${uuid}-city-mailing`}
                    className="block mb-1"
                  >
                    {t("FACStep-three-city")}
                  </label>
                  <input
                    id={`${uuid}-city-mailing`}
                    type="text"
                    placeholder="City"
                    {...FACStepThreeRegister("mailingCity", {
                      required:
                        "Please enter your city for us to mail the packet to",
                    })}
                  />
                  <FormInputError
                    id={`${uuid}-city-mailing-error`}
                    errorMessage={errors.mailingCity?.message}
                  />
                </div>

                <div>
                  <Controller
                    name="mailingState"
                    control={control}
                    render={() => (
                      <RELEASING_AutoCompleteComboBox
                        labelName={t("FACStep-three-state")}
                        inputPlaceholderText={t(
                          "FACStep-three-state-placeholder"
                        )}
                        options={[
                          {
                            value: "all",
                            displayAs: t("FACStep-three-state-optn"),
                            selectedPolicyDisplayAs: t(
                              "FACStep-three-state-optn"
                            ),
                            isDisplayOnly: true,
                          },
                          ...states.map((state) => ({
                            value: state.abbreviation,
                            displayAs: state.name,
                            selectedPolicyDisplayAs: state.name,
                            isDisplayOnly: true,
                          })),
                        ]}
                        selectedOption={selectedState}
                        setSelectedOption={(option) => {
                          setSelectedState(option);
                          if (option?.value !== "all") {
                            clearErrors("mailingState");
                            setValue("mailingState", option.value);
                          } else {
                            setError("mailingState", {
                              message: t("FACStep-three-state-requiredText"),
                            });
                            setValue("mailingState", "");
                          }
                        }}
                      />
                    )}
                    rules={{
                      required: t("FACStep-three-state-requiredText"),
                    }}
                  />

                  <FormInputError
                    id={`${uuid}-state-mailing-error`}
                    errorMessage={errors.mailingState?.message}
                  />
                </div>

                <div>
                  <label htmlFor={`${uuid}-zip-mailing`} className="block mb-1">
                    {t("FACStep-three-zipcode")}
                  </label>
                  <input
                    id={`${uuid}-zip-mailing`}
                    type="text"
                    placeholder="Zipcode"
                    {...FACStepThreeRegister("mailingZip", {
                      required: {
                        value: true,
                        message:
                          "Please enter your mailing zip code for us to mail the packet to",
                      },
                      pattern: {
                        value: /^\d{5}$/,
                        message: "Please enter a valid zipcode (5 digits)",
                      },
                      maxLength: {
                        value: 5,
                        message: "Please enter only 5 digits for zipcode",
                      },
                    })}
                  />
                  <FormInputError
                    id={`${uuid}-zip-mailing-error`}
                    errorMessage={errors.mailingZip?.message}
                  />
                </div>
              </div>
              <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1.5fr,1fr]">
                <div>
                  <label
                    htmlFor={`${uuid}-email-mailing`}
                    className="block mb-1"
                  >
                    {t("FACStep-three-email")}
                  </label>
                  <input
                    id={`${uuid}-email-mailing`}
                    type="text"
                    placeholder="Email"
                    {...FACStepThreeRegister(`mailingEmail`, {
                      required:
                        "Please enter an email address for better communication",
                      pattern: {
                        value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                        message: "Please enter a valid email",
                      },
                    })}
                  />
                  <FormInputError
                    id={`${uuid}-email-mailing-error`}
                    errorMessage={errors?.mailingEmail?.message}
                  />
                </div>
                <div>
                  <Controller
                    name="mailingRelationship"
                    control={control}
                    render={() => (
                      <RELEASING_AutoCompleteComboBox
                        labelName={t("FACStep-three-relationship")}
                        inputPlaceholderText={t("FACStep-three-select-optn")}
                        options={[
                          {
                            value: "all",
                            displayAs: t("FACStep-three-select-optn"),
                            selectedPolicyDisplayAs: t(
                              "FACStep-three-select-optn"
                            ),
                            isDisplayOnly: true,
                          },
                          {
                            value: "spouse",
                            displayAs: t("FACStep-three-select-optn-1"),
                            selectedPolicyDisplayAs: t(
                              "FACStep-three-select-optn-1"
                            ),
                            isDisplayOnly: true,
                          },
                          {
                            value: "child",
                            displayAs: t("FACStep-three-select-optn-2"),
                            selectedPolicyDisplayAs: t(
                              "FACStep-three-select-optn-2"
                            ),
                            isDisplayOnly: true,
                          },
                          {
                            value: "other",
                            displayAs: t("FACStep-three-select-optn-3"),
                            selectedPolicyDisplayAs: t(
                              "FACStep-three-select-optn-3"
                            ),
                            isDisplayOnly: true,
                          },
                        ]}
                        selectedOption={selectedRelationship}
                        setSelectedOption={(option) => {
                          setSelectedRelationship(option);
                          if (option?.value !== "all") {
                            setValue("mailingRelationship", option.value);
                          } else {
                            setValue("mailingRelationship", "");
                          }
                        }}
                      />
                    )}
                  />
                  <FormInputError
                    id={`${uuid}-relationship-mailing`}
                    errorMessage={errors?.mailingRelationship?.message}
                  />
                </div>
              </div>

              <div className="md:w-4/5">
                <label htmlFor={`${uuid}-claim-number`} className="block mb-1">
                  {t("FACStep-three-claim-number")}
                </label>
                <input
                  id={`${uuid}-claim-number`}
                  type="text"
                  placeholder="Please enter if a current claim number is known"
                  {...FACStepThreeRegister(`claimNumber`)}
                />
                <FormInputError
                  id={`${uuid}-claim-number-error`}
                  errorMessage={errors?.claimNumber?.message}
                />
              </div>

              <div>
                <label id="ID_messageLabel" htmlFor="ID_message">
                  {t("FACStep-three-special-character", {
                    wordCount: MAXIMUMWORDCOUNT,
                  })}
                </label>
                <textarea
                  id="ID_message"
                  type="text"
                  rows="6"
                  placeholder="Special delivery instruction"
                  {...FACStepThreeRegister("mailingComment", {
                    maxLength: {
                      value: MAXIMUMWORDCOUNT,
                      message: "Maximum characters exceeded.",
                    },
                    onChange: (e) => {
                      setCurrentWordCount(e.target.value.length);
                    },
                  })}
                />
                <span
                  className={
                    currentWordCount > MAXIMUMWORDCOUNT ? "ui-input-error" : ""
                  }
                >
                  ({currentWordCount}/{MAXIMUMWORDCOUNT})
                </span>
                <FormInputError
                  id="ID_emailError"
                  errorMessage={errors?.mailingComment?.message}
                />
              </div>
            </div>

            <div className="flex justify-end">
              <button
                className="ui-btn-secondary ui-btn-min-w mt-4"
                type="button"
                onClick={() => setFormStep(2)}
              >
                {t("FACStep-two-btn-1")}
              </button>

              <button className="ui-btn-primary ui-btn-min-w mt-4">
                {t("FACStep-two-btn-2")}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
